import Vue from 'vue'
import Router from 'vue-router'
import Layout from '../layout/index'
import mnLayout from '../layoutMN/index'
import mobileLayout from '../mobileLayout'
import mobileLayoutMN from '../mobieLayoutMn'
Vue.use(Router)
export const constantRoutes = [
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        component: () => import('../views/Home/index.vue'),
        name: 'Dashboard',
        hidden: true,
        meta: { title: 'Dashboard',
          icon: 'dashboard',
          affix: true
        }
      }
    ]
  },
  {
    path: '/cases',
    component: Layout,
    redirect: '/successfulCases',
    children: [
      {
        path: '/successfulCases',
        component: () => import('../views/successfulCases/index.vue'),
        name: 'successfulCases',
        hidden: true,
        meta: { title: 'successfulCases', icon: 'dashboard', affix: true }
      }
    ]
  },
  {
    path: '/services',
    component: Layout,
    redirect: '/technicalService',
    children: [
      {
        path: '/technicalService',
        hidden: true,
        component: () => import('../views/technicalService/index.vue'),
        name: 'technicalService',
        meta: { title: 'technicalService', icon: 'dashboard', affix: true }
      }
    ]
  },
  {
    path: '/about',
    component: Layout,
    redirect: '/aboutUs',
    children: [
      {
        path: '/aboutUs',
        hidden: true,
        component: () => import('../views/aboutUs/index.vue'),
        name: 'aboutUs',
        meta: { title: 'aboutUs', icon: 'dashboard', affix: true }
      }
    ]
  },
  {
    path: '/join',
    component: Layout,
    redirect: '/joinUs',
    children: [
      {
        path: '/joinUs',
        hidden: true,
        component: () => import('../views/joinUs/index.vue'),
        name: 'joinUs',
        meta: { title: 'joinUs', icon: 'dashboard', affix: true }
      }
    ]
  },
  {
    path: '/downloads',
    component: Layout,
    redirect: '/download',
    children: [
      {
        path: '/download',
        hidden: true,
        component: () => import('../views/download/index.vue'),
        name: 'download',
        meta: { title: 'download', icon: 'dashboard', affix: true }
      }
    ]
  },
  {
    path: '/dic',
    component: Layout,
    redirect: '/dictionary',
    children: [
      {
        path: '/dictionary',
        hidden: true,
        component: () => import('../views/dictionary/index.vue'),
        name: 'dictionary',
        meta: { title: 'dictionary', icon: 'dashboard', affix: true }
      }
    ]
  },
  // 蒙古文版本
  {
    path: '/mn',
    component: mnLayout,
    redirect: '/mnHome',
    children: [
      {
        path: '/mnHome',
        hidden: true,
        component: () => import('../views/mongolian/Home/index.vue'),
        name: 'mnHome',
        meta: { title: 'mnHome', icon: 'dashboard', affix: true }
      }
    ]
  },
  {
    path: '/mncases',
    component: mnLayout,
    redirect: '/mnSuccessfulCases',
    children: [
      {
        path: '/mnSuccessfulCases',
        hidden: true,
        component: () => import('../views/mongolian/successfulCases/index.vue'),
        name: 'mnSuccessfulCases',
        meta: { title: 'mnSuccessfulCases', icon: 'dashboard', affix: true }
      }
    ]
  },
  {
    path: '/mnservices',
    component: mnLayout,
    redirect: '/mnTechnicalService',
    children: [
      {
        path: '/mnTechnicalService',
        hidden: true,
        component: () => import('../views/mongolian/technicalService/index.vue'),
        name: 'mnTechnicalService',
        meta: { title: 'mnTechnicalService', icon: 'dashboard', affix: true }
      }
    ]
  },
  {
    path: '/mnAbout',
    component: mnLayout,
    redirect: '/mnAboutUs',
    children: [
      {
        path: '/mnAboutUs',
        hidden: true,
        component: () => import('../views/mongolian/aboutUs/index.vue'),
        name: 'mnAboutUs',
        meta: { title: 'mnAboutUs', icon: 'dashboard', affix: true }
      }
    ]
  },
  {
    path: '/mnjoin',
    component: mnLayout,
    redirect: '/mnJoinUs',
    children: [
      {
        path: '/mnJoinUs',
        hidden: true,
        component: () => import('../views/mongolian/joinUs/index.vue'),
        name: 'mnJoinUs',
        meta: { title: 'mnJoinUs', icon: 'dashboard', affix: true }
      }
    ]
  },
  {
    path: '/mndownloads',
    component: mnLayout,
    redirect: '/mnDownload',
    children: [
      {
        path: '/mnDownload',
        hidden: true,
        component: () => import('../views/mongolian/download/index.vue'),
        name: 'mnDownload',
        meta: { title: 'mnDownload', icon: 'dashboard', affix: true }
      }
    ]
  },
  // 移动端
  // 中文
  {
    path: '/mobile',
    component: mobileLayout,
    redirect: '/mobileHome',
    children: [
      {
        path: '/mobileHome',
        component: () => import('../views/mobile/Home/index.vue'),
        name: 'mobileHome',
        meta: { title: '首页',
          icon: 'ivu-icon-home',
          affix: true,
          roles: ['admin']
        }
      }

    ]
  },
  {
    path: '/mobileProduct',
    component: mobileLayout,
    redirect: '/mobileBmzh',
    children: [
      {
        path: '/mobileBmzh',
        hidden: true,
        component: () => import('../views/mobile/product/bmzh.vue'),
        name: 'mobileBmzh',
        meta: { title: '编码转换', icon: 'ivu-icon-home', affix: true, roles: ['admin'] }
      },
      {
        path: '/mobileTranslate',
        hidden: true,
        component: () => import('../views/mobile/product/jqfy.vue'),
        name: 'mobileTranslate',
        meta: { title: '机器翻译', icon: 'ivu-icon-home', affix: true, roles: ['admin'] }
      },
      {
        path: '/mobileOCR',
        hidden: true,
        component: () => import('../views/mobile/product/ocr.vue'),
        name: 'mobileOCR',
        meta: { title: 'OCR', icon: 'ivu-icon-home', affix: true, roles: ['admin'] }
      },
      {
        path: '/mobileYYSB',
        hidden: true,
        component: () => import('../views/mobile/product/yysb.vue'),
        name: 'mobileYYSB',
        meta: { title: '语音识别', icon: 'ivu-icon-home', affix: true, roles: ['admin'] }
      },
      {
        path: '/mobileYYHC',
        hidden: true,
        component: () => import('../views/mobile/product/yyhc.vue'),
        name: 'mobileYYHC',
        meta: { title: '语音合成', icon: 'ivu-icon-home', affix: true, roles: ['admin'] }
      },
      {
        path: '/mobileJZ',
        hidden: true,
        component: () => import('../views/mobile/product/mwjz.vue'),
        name: 'mobileJZ',
        meta: { title: '矫正系统', icon: 'ivu-icon-home', affix: true, roles: ['admin'] }
      },
      {
        path: '/mobileCD',
        hidden: true,
        component: () => import('../views/mobile/product/zxcd.vue'),
        name: 'mobileCD',
        meta: { title: '在线词典', icon: 'ivu-icon-home', affix: true, roles: ['admin'] }
      },
      {
        path: '/mobileWZZH',
        hidden: true,
        component: () => import('../views/mobile/product/wzzh.vue'),
        name: 'mobileWZZH',
        meta: { title: '文字转换', icon: 'ivu-icon-home', affix: true, roles: ['admin'] }
      },
      {
        path: '/mobileInputting',
        hidden: true,
        component: () => import('../views/mobile/product/Inputting.vue'),
        name: 'mobileInputting',
        meta: { title: '奥云输入法', icon: 'ivu-icon-home', affix: true, roles: ['admin'] }
      },
      {
        path: '/mobileDZZQ',
        hidden: true,
        component: () => import('../views/mobile/product/dzzq.vue'),
        name: 'mobileDZZQ',
        meta: { title: '电子桌签', icon: 'ivu-icon-home', affix: true, roles: ['admin'] }
      },
      {
        path: '/mobileTIKU',
        hidden: true,
        component: () => import('../views/mobile/product/tiku.vue'),
        name: 'mobileTIKU',
        meta: { title: '题库', icon: 'ivu-icon-home', affix: true, roles: ['admin'] }
      },
      {
        path: '/mobileWritting',
        hidden: true,
        component: () => import('../views/mobile/product/writting.vue'),
        name: 'mobileWritting',
        meta: { title: '智慧书法系统', icon: 'ivu-icon-home', affix: true, roles: ['admin'] }
      }

    ]
  },
  {
    path: '/mobileSuccessfulCases',
    component: mobileLayout,
    redirect: '/m_SuccessfulCases',
    children: [
      {
        path: '/m_SuccessfulCases',
        component: () => import('../views/mobile/successfulCases/index.vue'),
        name: 'm_SuccessfulCases',
        meta: { title: '成功案例', icon: 'ivu-icon-star1', affix: true, roles: ['admin'] }
      }

    ]
  },
  {
    path: '/mobileTechnicalService',
    component: mobileLayout,
    redirect: '/m_TechnicalService',
    children: [
      {
        path: '/m_TechnicalService',
        component: () => import('../views/mobile/technicalService/index.vue'),
        name: 'm_TechnicalService',
        meta: { title: '技术服务', icon: 'ivu-icon-heart', affix: true }
      }
    ]
  },
  {
    path: '/mobileDownload',
    component: mobileLayout,
    redirect: '/m_Download',
    children: [
      {
        path: '/m_Download',
        component: () => import('../views/mobile/download/index.vue'),
        name: 'm_Download',
        meta: { title: '下载', icon: 'ivu-icon-star1', affix: true, roles: ['admin'] }
      }

    ]
  },
  {
    path: '/mobileAboutUs',
    component: mobileLayout,
    redirect: '/m_AboutUs',
    children: [
      {
        path: '/m_AboutUs',
        component: () => import('../views/mobile/aboutAs/index.vue'),
        name: 'm_AboutUs',
        meta: { title: '关于我们', icon: 'ivu-icon-4', affix: true }
      }
    ]
  },
  {
    path: '/mobileJoinUs',
    component: mobileLayout,
    redirect: '/m_JoinUs',
    children: [
      {
        path: '/m_JoinUs',
        component: () => import('../views/mobile/joinUs/index.vue'),
        name: 'm_JoinUs',
        meta: { title: '诚聘英才', icon: 'ivu-icon-3', affix: true }
      }
    ]
  },
  {
    path: 'https://ai.nmgoyun.com/#/AI',
    component: mobileLayout,
    name: 'm_AI',
    meta: { title: '奥云AI', icon: 'ivu-icon-3', affix: true }
  },
  // {
  //   path: 'https://chat.nmgoyun.com/#/home',
  //   component: mobileLayout,
  //   name: 'm_chat',
  //   meta: { title: '奥云大模型', icon: 'ivu-icon-3', affix: true }
  // },

  // 移动端
  // 蒙古文
  {
    path: '/mobileMN',
    component: mobileLayoutMN,
    redirect: '/mobileHomeMN',
    children: [
      {
        path: '/mobileHomeMN',
        component: () => import('../views/mongolianMobile/Home/index.vue'),
        name: 'mobileHomeMN',
        meta: { title: 'ᠭᠤᠤᠯ  ᠨᠢᠭᠤᠷ', icon: 'ivu-icon-home', affix: true, mn: true, roles: ['admin'] }
      }

    ]
  },
  {
    path: '/mobileSuccessfulCasesMN',
    component: mobileLayoutMN,
    redirect: '/mn_SuccessfulCase',
    children: [
      {
        path: '/mn_SuccessfulCase',
        component: () => import('../views/mongolianMobile/successfulCases/index.vue'),
        name: 'mn_SuccessfulCase',
        meta: { title: 'ᠠᠮᠵᠢᠯᠳᠠ ᠲᠠᠢ  ᠵᠢᠱ᠌ᠢᠶ᠎ᠡ', icon: 'ivu-icon-star1', mn: true, affix: true, roles: ['admin'] }
      }

    ]
  },
  {
    path: '/mobileTechnicalServiceMN',
    component: mobileLayoutMN,
    redirect: '/mn_TechnicalService',
    children: [
      {
        path: '/mn_TechnicalService',
        component: () => import('../views/mongolianMobile/technicalService/index.vue'),
        name: 'mn_TechnicalService',
        meta: { title: 'ᠮᠡᠷᠭᠡᠵᠢᠯ  ᠦᠢᠯᠡᠴᠢᠯᠡᠭᠡ', icon: 'ivu-icon-heart', mn: true, affix: true }
      }
    ]
  },
  {
    path: '/mobileDownloadMN',
    component: mobileLayoutMN,
    redirect: '/mn_download',
    children: [
      {
        path: '/mn_download',
        component: () => import('../views/mongolianMobile/download/index.vue'),
        name: 'mn_download',
        meta: { title: ' ᠪᠢᠴᠢᠭᠯᠡᠭᠦᠷ ᠪᠠ ᠲᠢᠭ', icon: 'ivu-icon-3', mn: true, affix: true }
      }
    ]
  },
  {
    path: '/mobileAboutUsMN',
    component: mobileLayoutMN,
    redirect: '/mn_AboutUs',
    children: [
      {
        path: '/mn_AboutUs',
        component: () => import('../views/mongolianMobile/aboutUs/index.vue'),
        name: 'mn_AboutUs',
        meta: { title: 'ᠪᠢᠳᠡᠨ ᠎ᠤ ᠲᠣᠬᠠᠢ', icon: 'ivu-icon-4', mn: true, affix: true }
      }
    ]
  },
  {
    path: '/mobileJoinUsMN',
    component: mobileLayoutMN,
    redirect: '/mn_JoinUs',
    children: [
      {
        path: '/mn_JoinUs',
        component: () => import('../views/mongolianMobile/joinUs/index.vue'),
        name: 'mn_JoinUs',
        meta: { title: 'ᠴᠢᠳᠠᠪᠤᠷᠢᠲᠠᠨ ᠡᠯᠰᠡᠬᠦ', icon: 'ivu-icon-3', mn: true, affix: true }
      }
    ]
  },
  {
    path: '/mobileProducts',
    component: mobileLayoutMN,
    redirect: '/mobileBmzhMN',
    children: [
      {
        path: '/mobileBmzhMN',
        hidden: true,
        component: () => import('../views/mongolianMobile/product/bmzh.vue'),
        name: 'mobileBmzhMN',
        meta: { title: ' ᠺᠣᠳ᠋ ᠬᠥᠷᠪᠡᠭᠦᠯᠬᠦ ', icon: 'ivu-icon-home', affix: true, roles: ['admin'] }
      },
      {
        path: '/mobileTranslateMN',
        hidden: true,
        component: () => import('../views/mongolianMobile/product/jqfy.vue'),
        name: 'mobileTranslateMN',
        meta: { title: ' ᠮᠠᠱᠢᠨ ᠣᠷᠴᠢᠭᠤᠯᠭ᠎ᠠ', icon: 'ivu-icon-home', affix: true, roles: ['admin'] }
      },
      {
        path: '/mobileOCRMN',
        hidden: true,
        component: () => import('../views/mongolianMobile/product/ocr.vue'),
        name: 'mobileOCRMN',
        meta: { title: ' OCR ᠢᠯᠭᠠᠨ ᠲᠠᠨᠢᠬᠤ', icon: 'ivu-icon-home', affix: true, roles: ['admin'] }
      },
      {
        path: '/mobileYYSBMN',
        hidden: true,
        component: () => import('../views/mongolianMobile/product/yysb.vue'),
        name: 'mobileYYSBMN',
        meta: { title: 'ᠠᠪᠢᠶ᠎ᠠ ᠵᠢ ᠢᠯᠭᠠᠨ ᠲᠠᠨᠢᠬᠤ ᠱᠢᠰᠲ᠋ᠧᠮ', icon: 'ivu-icon-home', affix: true, roles: ['admin'] }
      },
      {
        path: '/mobileYYHCMN',
        hidden: true,
        component: () => import('../views/mongolianMobile/product/yyhc.vue'),
        name: 'mobileYYHCMN',
        meta: { title: 'ᠠᠪᠢᠶ᠎ᠠ ᠨᠡᠢᠯᠡᠭᠦᠯᠬᠦ', icon: 'ivu-icon-home', affix: true, roles: ['admin'] }
      },
      {
        path: '/mobileJZMN',
        hidden: true,
        component: () => import('../views/mongolianMobile/product/mwjz.vue'),
        name: 'mobileJZMN',
        meta: { title: 'ᠦᠰᠦᠭ ᠵᠠᠯᠠᠷᠠᠭᠤᠯᠬᠤ  ', icon: 'ivu-icon-home', affix: true, roles: ['admin'] }
      },
      {
        path: '/mobileCDMN',
        hidden: true,
        component: () => import('../views/mongolianMobile/product/zxcd.vue'),
        name: 'mobileCDMN',
        meta: { title: 'ᠰᠦᠯᠵᠢᠶᠡᠨ ᠳᠡᠭᠡᠷᠡᠬᠢ ᠲᠣᠯᠢ  ᠪᠢᠴᠢᠭ ', icon: 'ivu-icon-home', affix: true, roles: ['admin'] }
      },
      {
        path: '/mobileWZZHMN',
        hidden: true,
        component: () => import('../views/mongolianMobile/product/wzzh.vue'),
        name: 'mobileWZZHMN',
        meta: { title: ' ᠺᠢᠷᠢᠯ᠂ ᠤᠯᠠᠮᠵᠢᠯᠠᠯᠲᠤ ᠪᠠᠭᠤᠯᠭᠠᠬᠤ ', icon: 'ivu-icon-home', affix: true, roles: ['admin'] }
      },
      {
        path: '/mobileInputtingMN',
        hidden: true,
        component: () => import('../views/mongolianMobile/product/Inputting.vue'),
        name: 'mobileInputtingMN',
        meta: { title: '《ᠣᠶᠤᠨ》ᠦᠰᠦᠭ ᠣᠷᠤᠭᠤᠯᠬᠤ', icon: 'ivu-icon-home', affix: true, roles: ['admin'] }
      },
      {
        path: '/mobileDZZQMN',
        hidden: true,
        component: () => import('../views/mongolianMobile/product/dzzq.vue'),
        name: 'mobileDZZQMN',
        meta: { title: 'ᠣᠯᠠᠨ ᠬᠡᠯᠡᠨ᠎ᠤ ᠡᠯᠧᠺᠲ᠋ᠷᠤᠨ ᠨᠡᠷ᠎ᠡ᠎ᠶᠢᠨ ᠫᠠᠢᠢᠰᠠ', icon: 'ivu-icon-home', affix: true, roles: ['admin'] }
      },
      {
        path: '/mobileTIKUMN',
        hidden: true,
        component: () => import('../views/mongolianMobile/product/tiku.vue'),
        name: 'mobileTIKUMN',
        meta: { title: ' ᠰᠦᠯᠵᠢᠶᠡᠨ ᠳᠡᠭᠡᠷᠡᠬᠢ ᠰᠡᠳᠦᠪ ᠦ᠋ᠨ ᠬᠦᠮᠦᠷᠭᠡ ', icon: 'ivu-icon-home', affix: true, roles: ['admin'] }
      },
      {
        path: '/mobileWrittingMN',
        hidden: true,
        component: () => import('../views/mongolianMobile/product/writting.vue'),
        name: 'mobileWrittingMN',
        meta: { title: 'ᠤᠶᠤᠨᠴᠢ ᠤᠷᠠᠨ ᠪᠢᠴᠢᠯᠭᠡ ᠎ᠶᠢᠨ ᠰᠢᠰᠲ᠋ᠧᠮ', icon: 'ivu-icon-home', affix: true, roles: ['admin'] }
      }

    ]
  },
  {
    path: 'https://ai.nmgoyun.com/',
    component: mobileLayoutMN,
    name: 'mobileAI',
    meta: { title: 'ᠣᠶᠤᠨ AI', icon: 'ivu-icon-3', mn: true, affix: true }
  },
  // {
  //   path: 'https://chat.nmgoyun.com/',
  //   component: mobileLayoutMN,
  //   name: 'mobileChat',
  //   meta: { title: 'ᠣᠶᠤᠨ ᠲᠣᠮᠤ ᠵᠠᠭᠪᠤᠷ', icon: 'ivu-icon-3', mn: true, affix: true }
  // }
]
const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter () {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js